import { Component } from "react";
import {SEO_DEFAULT_TITLE,SEO_DEFAULT_DESCRIPTION,SEO_DEFAULT_SITE_NAME,SITE_URL} from "../util/config";

const getTagByName = (tags, name) => {
  for (let i = 0; i < tags.length; i++) {
    const tag = tags[i];
    if (tag.getAttribute("name") === name) {
      return tag;
    }
  }
  return null;
};

const getTagByProperty = (tags, property) => {
  for (let i = 0; i < tags.length; i++) {
    const tag = tags[i];
    if (tag.getAttribute("property") === property) {
      return tag;
    }
  }
  return null;
};

// attr: "name" or "property" ; value falsy => tag is removed (if present)
const setOrRemoveMeta = (head, meta, attr, key, value) => {
  const find = attr === "property" ? getTagByProperty : getTagByName;
  let el = find(meta, key);
  if (value) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      head.appendChild(el);
    }
    el.setAttribute("content", value);
  } else if (el) {
    el.parentNode.removeChild(el);
  }
};

const toAbsoluteUrl = url => {
  if (!url) return null;
  return /^https?:\/\//i.test(url) ? url : SITE_URL + (url.startsWith("/") ? url : "/" + url);
};

const SOCIAL_PROPS = [
  "title", "description", "image", "imageWidth", "imageHeight", "url", "type", "siteName"
];

export default class SEO extends Component {
  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (SOCIAL_PROPS.some(key => prevProps[key] !== this.props[key]) || prevProps.noIndex !== this.props.noIndex) {
      this.init();
    }
  }

  componentWillUnmount() {
    this.setValues({
      title: SEO_DEFAULT_TITLE,
      description: SEO_DEFAULT_DESCRIPTION,
      noIndex: false
    });
  }

  init() {
    this.setValues(this.props);
  }

  setValues({ title, description, noIndex, image, imageWidth, imageHeight, url, type, siteName }) {
    const head = document.getElementsByTagName("head")[0];
    const meta = head.getElementsByTagName("meta");

    const titleEl = head.getElementsByTagName("title")[0];
    let descriptionEl = getTagByName(meta, "description");

    const resolvedTitle = title || SEO_DEFAULT_TITLE;
    const resolvedDescription = description || SEO_DEFAULT_DESCRIPTION;

    if (titleEl) {
      titleEl.innerText = resolvedTitle;
    } else {
      console.warn("Title Element Not Found");
    }

    if (descriptionEl) {
      descriptionEl.setAttribute("content", resolvedDescription);
    } else {
      console.warn("Description Element Not Found");
    }

    let robotsEl = getTagByName(meta, "robots");
    if (noIndex) {
      if (!robotsEl) {
        let robotsEl = document.createElement("meta");
        robotsEl.setAttribute("name", "robots");
        robotsEl.setAttribute("content", "noindex");
        head.appendChild(robotsEl);
      } else {
        robotsEl.setAttribute("content", "noindex");
      }
    } else {
      if (robotsEl) {
        robotsEl.parentNode.removeChild(robotsEl);
      }
    }

    // Social tags (Open Graph + Twitter/X) - only populated when an image is provided
    const resolvedImage = toAbsoluteUrl(image);
    const resolvedUrl = resolvedImage ? (url ? toAbsoluteUrl(url) : SITE_URL + window.location.pathname) : null;

    setOrRemoveMeta(head, meta, "property", "og:type", resolvedImage ? (type || "article") : null);
    setOrRemoveMeta(head, meta, "property", "og:title", resolvedImage ? resolvedTitle : null);
    setOrRemoveMeta(head, meta, "property", "og:description", resolvedImage ? resolvedDescription : null);
    setOrRemoveMeta(head, meta, "property", "og:image", resolvedImage);
    setOrRemoveMeta(head, meta, "property", "og:image:width", resolvedImage && imageWidth ? String(imageWidth) : null);
    setOrRemoveMeta(head, meta, "property", "og:image:height", resolvedImage && imageHeight ? String(imageHeight) : null);
    setOrRemoveMeta(head, meta, "property", "og:url", resolvedUrl);
    setOrRemoveMeta(head, meta, "property", "og:site_name", resolvedImage ? (siteName || SEO_DEFAULT_SITE_NAME) : null);

    setOrRemoveMeta(head, meta, "name", "twitter:card", resolvedImage ? "summary_large_image" : null);
    setOrRemoveMeta(head, meta, "name", "twitter:title", resolvedImage ? resolvedTitle : null);
    setOrRemoveMeta(head, meta, "name", "twitter:description", resolvedImage ? resolvedDescription : null);
    setOrRemoveMeta(head, meta, "name", "twitter:image", resolvedImage);
  }

  render() {
    return null;
  }
}
